import { Box, Typography } from '@mui/material'
import { useEffect } from 'react'
import { Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import AdxEmployeeAvatar from 'components/reusable/employeeAvatar/AdxEmployeeAvatar'
import AdxDatePicker from 'components/custom/AdxDatePicker'
import { BorderColor } from '@mui/icons-material'

const TerminateEmployeeForm = ({ getValidationSchema, formikProps, staff }) => {
  const { setFieldValue, values, validateForm } = formikProps

  const data = [{ name: staff?.name, imgUrl: staff?.profile_image_url }]

  const validationSchema = Yup.object().shape({
    date: Yup.date().required('Please indicate date'),
  })

  useEffect(() => {
    getValidationSchema(validationSchema)
  }, [])

  useEffect(() => {
    validateForm()
  }, [getValidationSchema])

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start',
          backgroundColor: 'default-background.main',
          p: 2,
          gap: 2,
          borderRadius: '4.5px',
        }}
      >
        <Box sx={{ width: 52 }}>
          <AdxEmployeeAvatar max={1} data={data} />
        </Box>
        <Box sx={{}}>
          <Typography variant="body1" color="dark-gray-text.main" sx={{ fontWeight: 'bold' }}>
            {staff?.name}
          </Typography>
          <Typography variant="body1" color="light-gray-text.main">
            {staff?.designation && staff?.department
              ? staff?.designation + ', ' + staff?.department
              : staff?.designation
              ? staff?.designation
              : staff?.department
              ? staff?.department
              : ''}
          </Typography>
        </Box>
      </Box>
      <Box>
        <Typography align="left" variant="body1" color="light-gray-text.main">
          You are about to terminate this staff from your organization. Please fill in the
          offboarding date to proceed.
        </Typography>
      </Box>
      <Box sx={{ width: 1 }}>
        <Field
          as={AdxDatePicker}
          label={`Off-Boarding Date`}
          name="date"
          type="date"
          value={values.date}
          onChange={(e) => {
            setFieldValue(`date`, e)
          }}
          errorMessage={<ErrorMessage name="date" />}
        />
      </Box>
    </Box>
  )
}

export default TerminateEmployeeForm
